<template>
  <b-list-group flush>
    <b-list-group-item href="#" @click.prevent="selectStudy(study.created_at._id)" v-for="(study, $index) in list" :key="$index" :active="study.created_at._id === active">
      <b-row>
        <b-col cols="2" class="pr-0">
          <img class="img pr-1 img-thumbnail" :src="boundingBoxes(study.created_at.cell.submission)" />
        </b-col>
        <b-col class="d-flex flex-column">
          <b-row class="mb-1">
            <b-col cols="9">
              <h6 class="color-white pt-1 mb-0 d-inline-block text-truncate" style="width: calc(100% - 0.25rem);">
                {{ study.patient.demographics.name || study.patient.identifier }}
              </h6>
            </b-col>
            <b-col cols="3" class="text-right">
              <small><em>{{ formatDate(study.created_at.date) }}</em></small>
            </b-col>
            <div class="float-right"></div>
          </b-row>
          <p class="mb-auto">
            <span class="mr-3" v-if="Boolean(study.patient.demographics && study.patient.demographics.name)">ID: {{ study.patient.identifier }},</span>
            <span v-if="study.patient.demographics && study.patient.demographics.ageGroup">Age: {{ study.patient.demographics.ageGroup }}<br /></span>
            Date: {{ formatFullDate(study.created_at.date) }}
          </p>
          <b-row class="mt-2">
            <b-col>
              <b-badge pill class="indicator high mr-2 px-2" v-if="conclusion(study)">
                <font-awesome-icon icon="circle" class="mr-1"></font-awesome-icon> {{ conclusion(study) }}
              </b-badge>
              <b-badge pill class="indicator nothing px-2" v-if="study.feedback">
                <font-awesome-icon icon="comment-dots" class="mr-1"></font-awesome-icon> Feedback recorded
              </b-badge>
            </b-col>
            <b-col cols="3" class="text-right">
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-list-group-item>
  </b-list-group>
</template>

<script>
import moment from 'moment'
import { apiRoute } from './../../../helpers'

export default {
  props: {
    list: {
      type: Array,
      default: () => { return [] }
    },
    active: {
      type: String,
      default: null
    }
  },
  methods: {
    selectStudy: function (id) {
      this.$emit('study-selected', id)
    },
    formatDate: function (date) {
      return moment(date).fromNow()
    },
    formatFullDate: function (date) {
      return moment(date).format('D MMM YYYY, HH:mm')
    },
    isPleural: function (selected) {
      if (selected && selected.created_at && selected.created_at.cell && selected.created_at.cell.submission) {
        const _attachments = selected.created_at.cell.submission.attachments
        if (_attachments && Array.isArray(_attachments) && _attachments.length > 0) {
          const _attachment = _attachments[0]
          if (_attachment && _attachment.response && _attachment.response.labels && Array.isArray(_attachment.response.labels) && _attachment.response.labels.length > 0) {
            const _pathologies = _attachment.response.labels[0].pathologies
            if (_pathologies && Array.isArray(_pathologies) && _pathologies.length > 0) {
              return _pathologies.filter(_pathology => _pathology.predicted_diagnosis === 'pleuraleffusion').length > 0
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isPneumo: function (selected) {
      if (selected && selected.created_at && selected.created_at.cell && selected.created_at.cell.submission) {
        const _attachments = selected.created_at.cell.submission.attachments
        if (_attachments && Array.isArray(_attachments) && _attachments.length > 0) {
          const _attachment = _attachments[0]
          if (_attachment && _attachment.response && _attachment.response.labels && Array.isArray(_attachment.response.labels) && _attachment.response.labels.length > 0) {
            const _pathologies = _attachment.response.labels[0].pathologies
            if (_pathologies && Array.isArray(_pathologies) && _pathologies.length > 0) {
              return _pathologies.filter(_pathology => _pathology.predicted_diagnosis === 'pneumothorax').length > 0
            } else {
              return false
            }
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    conclusion: function (selected) {
      if (this.isPleural(selected)) {
        if (this.isPneumo(selected)) {
          return 'Suspected Pleural Effusion and Pneumothorax'
        } else {
          return 'Suspected Pleural Effusion'
        }
      } else if (this.isPneumo(selected)) {
        return 'Suspected Pneumothorax'
      } else {
        return null
      }
    },
    getConclusion: function (name) {
      if (name.indexOf('high') > -1) {
        return ''
      } else if (name.indexOf('intermediate') > -1 || name.indexOf('low') > -1) {
        return ''
      } else if (name.indexOf('other') > -1) {
        return ''
      } else {
        return ''
      }
    },
    getIcon: function (name) {
      if (name.indexOf('high') > -1) {
        return 'circle'
      } else if (name.indexOf('intermediate') > -1 || name.indexOf('low') > -1) {
        return 'circle'
      } else {
        return 'heartbeat'
      }
    },
    getIndicator: function (name) {
      if (name.indexOf('high') > -1) {
        return 'high'
      } else if (name.indexOf('intermediate') > -1 || name.indexOf('low') > -1) {
        return 'high'
      } else {
        return 'nothing'
      }
    },
    boundingBoxes: function (result) {
      if (result) {
        if (result.attachments[0].path.indexOf('http') === -1) {
          return apiRoute() + result.attachments[0].path
        } else {
          return result.attachments[0].path
        }
      } else {
        return null
      }
    }
  }
}
</script>
